import React from 'react';

import { HomePageOnboardContextProvider } from '../../home-page-onboard-context';
import { GettingStartedPopup } from './getting-started-popup';
import { GettingStartedPopupButton } from './getting-started-popup-button';
import { useShouldShowGuide } from '../../hooks/use-should-show-guide';
import { useEnableHomePage2 } from '../../../../feature-flags/hooks/use-enable-home-page2';

export const GettingStartedPopupToggler = () => {
  const isHomePageV2Enabled = useEnableHomePage2();
  const shouldShowGuide = useShouldShowGuide() && !isHomePageV2Enabled;

  if (shouldShowGuide) {
    return (
      <HomePageOnboardContextProvider isPopup>
        <GettingStartedPopupButton />
        <GettingStartedPopup />
      </HomePageOnboardContextProvider>
    );
  }
};
